<template>
  <div class="terms-modal" v-if="visible">
    <div class="terms-modal-overlay" @click="closeModal"></div>
    <div class="terms-modal-container">
      <div class="terms-modal-header">
        <h4>服务条款和免责声明</h4>
        <button class="terms-modal-close" @click="closeModal">×</button>
      </div>
      <div class="terms-modal-content">
        <div class="terms-section">
          <h5>【重要提示】</h5>
          <p>在使用本网站服务前，请您务必仔细阅读并充分理解本协议所有条款。本协议描述了您与本网站之间关于网站服务使用的权利和义务。<strong>勾选"我已阅读并同意《服务条款和免责声明》"即表示您已充分阅读、理解并同意接受本协议的全部内容。</strong>如您不同意本协议的任何条款，请勿注册或使用本网站服务。</p>
        </div>

        <div class="terms-section">
          <h5>一、服务描述</h5>
          <p>本网站提供以下服务：</p>
          <ol>
            <li>面试题收集与展示：本网站收集网络上公开流传的面试题目，仅供学习参考，并且本网站不保证面试题的准确性、实用性和时效性，请您自行辨别。</li>
            <li>语音识别功能：将用户语音回答转化为文本，以便于分析评估，但是可能存在识别不准确、误解或无法识别的情况，由此产生的后果本网站不承担责任。</li>
            <li>AI评价服务：利用人工智能技术对用户回答进行评价和反馈，但是AI评价仅作为参考，不代表权威评价标准，可能存在评价偏差或不当判断。</li>
            <li>语聊房功能：提供用户之间的交流平台，但是本网站无法全面监控用户在语聊房中的言行，请您谨慎使用并自行判断，如有不当言论或行为，请及时举报。</li>
          </ol>
        </div>

        <div class="terms-section">
          <h5>二、用户注册与账号安全</h5>
          <p>1. 您需要提供真实、准确、完整的个人信息进行注册。</p>
          <p>2. 您有责任保护账号信息安全，因账号泄露导致的一切损失由您自行承担。</p>
          <p>3. 发现账号遭到未授权使用或存在安全漏洞时，应立即通知本网站。</p>
        </div>

        <div class="terms-section">
          <h5>三、用户行为规范</h5>
          <p>您在使用本网站服务时应遵守以下规定：</p>
          <ol>
            <li>遵守中华人民共和国相关法律法规。</li>
            <li>不得传播违法、有害、色情、暴力、侮辱、诽谤等信息。</li>
            <li>不得侵犯他人知识产权、隐私权等合法权益。</li>
            <li>不得利用本网站服务从事任何违法或不当行为。</li>
          </ol>
        </div>

        <div class="terms-section">
          <h5>四、风险提示与免责声明</h5>
          <ol>
            <li><strong>面试题内容风险</strong>：本网站收集的面试题仅供参考，不保证其准确性、实用性和时效性，并且网站会您上传的自定义题目放入题库，可能会用于本网站的题库展示中。</li>
            <li><strong>语音识别风险</strong>：语音识别技术可能存在识别不准确、误解或无法识别的情况，由此产生的后果本网站不承担责任。</li>
            <li><strong>AI评价风险</strong>：AI评价仅作为参考，不代表权威评价标准，可能存在评价偏差或不当判断。</li>
            <li><strong>语聊房风险</strong>：用户在语聊房中的言行本网站无法全面监控，可能遇到不当言论或行为，请谨慎使用并自行判断。</li>
            <li><strong>内容风险</strong>：用户应自行辨别网站内容的真实性和可用性，本网站不对因内容导致的任何直接或间接损失负责。</li>
            <li><strong>安全风险</strong>：尽管本网站采取安全措施保护用户数据，但无法保证绝对安全，可能因网络攻击等原因导致数据泄露。</li>
            <li><strong>技术风险</strong>：网站可能因技术故障、网络问题、系统维护等原因导致服务中断或数据丢失。</li>
          </ol>
        </div>

        <div class="terms-section">
          <h5>五、知识产权</h5>
          <p>1. 本网站的所有内容（包括但不限于文字、图片、音频、视频、程序、设计等）的知识产权归本网站所有。</p>
          <p>2. 未经本网站许可，不得以任何形式复制、传播、展示、表演、录制、二次开发或创建衍生作品。</p>
          <p>3. 用户提交的内容，用户保留其知识产权，但授予本网站全球范围内的免费许可使用权。</p>
        </div>

        <div class="terms-section">
          <h5>六、隐私保护</h5>
          <p>1. 本网站重视用户隐私保护，收集用户信息仅用于提供和改进服务。</p>
          <p>2. 未经用户许可，不会向第三方披露用户个人信息，法律法规要求的情况除外。</p>
          <p>3. 用户授权本网站收集其语音数据并用于语音识别及服务改进。</p>
        </div>

        <div class="terms-section">
          <h5>七、服务变更、中断或终止</h5>
          <p>1. 本网站有权在必要时修改、中断或终止服务。</p>
          <p>2. 用户违反服务条款时，本网站有权暂停或终止对该用户的服务。</p>
        </div>

        <div class="terms-section">
          <h5>八、法律适用与争议解决</h5>
          <p>1. 本协议适用中华人民共和国法律。</p>
          <p>2. 因本协议引起的争议，双方应友好协商解决；协商不成的，提交本网站运营方所在地有管辖权的人民法院诉讼解决。</p>
        </div>

        <div class="terms-section">
          <h5>九、其他条款</h5>
          <p>1. 本网站保留对本协议的最终解释权。</p>
          <p>2. 本协议未尽事宜，参照相关法律法规及本网站其他规则。</p>
        </div>
      </div>
      <div class="terms-modal-footer">
        <button class="btn terms-agree-btn" @click="agreeAndClose">同意并关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    agreeAndClose() {
      this.$emit('agree');
    }
  }
};
</script>

<style scoped>
.terms-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
}

.terms-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.terms-modal-container {
  position: relative;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 1002;
}

.terms-modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.terms-modal-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.terms-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.terms-modal-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.terms-section {
  margin-bottom: 24px;
}

.terms-section h5 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #333;
}

.terms-section p {
  margin: 8px 0;
  font-size: 14px;
  line-height: 1.6;
  color: #444;
}

.terms-section ol, .terms-section ul {
  margin: 8px 0;
  padding-left: 20px;
}

.terms-section li {
  margin: 8px 0;
  font-size: 14px;
  line-height: 1.6;
  color: #444;
}

.terms-section strong {
  font-weight: 600;
  color: #222;
}

.terms-modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #eee;
  text-align: right;
}

.terms-agree-btn {
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.terms-agree-btn:hover {
  background-color: #3a80d2;
}
</style> 